import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["failureBanner", "sendButton", "submitButton"]
  static outlets = []

  connect() {
    this.checkSubmitBlocking()
  }

  failureBannerTargetConnected() {
    this.checkSubmitBlocking()
  }

  failureBannerTargetDisconnected() {
    this.checkSubmitBlocking()
  }

  dismissFailure(event) {
    event.preventDefault()
    const banner = event.target.closest('[data-ccct-delivery-status-target="failureBanner"]')
    if (banner) banner.remove()
  }

  checkSubmitBlocking() {
    const submitButton = this.hasSubmitButtonTarget
      ? this.submitButtonTarget
      : document.querySelector('[name="submit_button"][value="real_save"]')
    if (!submitButton) return

    const hasFailure = this.hasFailureBannerTarget
    submitButton.disabled = hasFailure
    submitButton.title = hasFailure ? "Resolve delivery failure before submitting" : ""
  }
}
